export default "__VITE_ASSET__DfWyAK____"